import * as React from 'react';

const TwitchIcon = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m16.25 9.36-2.5 2.57h-2.5l-2.19 2.25v-2.25H6.25V2.29h10z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#9146FF",
        d: "M5.63 1 2.5 4.21V15.8h3.75V19l3.13-3.21h2.5L17.5 10V1zm10.62 8.36-2.5 2.57h-2.5l-2.19 2.25v-2.25H6.25V2.29h10z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#9146FF",
        d: "M14.38 4.54h-1.26v3.85h1.26zM10.94 4.54H9.69v3.85h1.25z"
    }));

export { TwitchIcon };
//# sourceMappingURL=Twitch.mjs.map
